import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { BillingService } from "../billing.service";
import { ActivatedRoute, Router } from "@angular/router";
import { EMPTY, from, mergeMap, Subject, takeUntil } from "rxjs";

@Component({
    selector: "payment-failed",
    templateUrl: "./payment-failed.component.html",
    providers: [
        BillingService,
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PaymentFailedComponent implements OnInit, OnDestroy {

    protected errorMessage: string;
    protected description: string;

    private _destroy$ = new Subject<void>();

    constructor(
        private route: ActivatedRoute,
        private router: Router,
    ) { }

    ngOnInit() {
        this.route.params
            .pipe(
                mergeMap(params => {
                    const teamId = params['teamId'];
                    if (!teamId) {
                        return this.router.navigate(['/login']);
                    } else {
                        return EMPTY;
                    }
                }),
                takeUntil(this._destroy$)
            ).subscribe();

        this.errorMessage = 'payment_unsuccessful.3DSecure';
        this.description = 'payment_unsuccessful.3DSecure.contact';
    }

    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
}